// libs
import React, { memo, useState } from "react";

// global components
import { getAkamaiUrl } from "shared/helpers/utils";

// components
import Error from "shared/components/AuthModal/components/Error";
import LinkButton from "shared/components/AuthModal/components/LinkButton";

// contexts
import { useAuthModalContext } from "shared/components/AuthModal/AuthModalContext";

// helpers
import { getSocialUrl } from "./helpers";

// constants
import { TEXTS, FB_IMAGE, G_PLUS_IMAGE, FORM_STATE } from "shared/components/AuthModal/constants";
import { SOCIAL_PROVIDERS } from "./constants";

// styled components
import { Container, Image, Button } from "./styles";

function SocialLogin() {
    const [error, setError] = useState("");
    const [isDisabled, setDisabled] = useState(false);
    const { formState, setFormState } = useAuthModalContext();

    const doSocialClick = (provider: SOCIAL_PROVIDERS) => {
        setDisabled(true);
        try {
            window.location.href = getSocialUrl(provider, window.location.href);
        } catch (e) {
            setDisabled(false);
            setError(TEXTS.OOPS);
        }
    };

    const onFbClick = () => doSocialClick(SOCIAL_PROVIDERS.FACEBOOK);
    const onGoogleClick = () => doSocialClick(SOCIAL_PROVIDERS.GOOGLE);

    return (
        <Container>
            {error.length > 0 && <Error>{error}</Error>}
            <Button className="fb-btn" onClick={onFbClick} data-test="fb-btn" disabled={isDisabled}>
                <Image src={getAkamaiUrl(FB_IMAGE)} alt="Facebook" />
                {TEXTS.REGISTER_FACEBOOK}
            </Button>

            <Button
                className="g-btn"
                onClick={onGoogleClick}
                data-test="g-btn"
                disabled={isDisabled}
            >
                <Image src={getAkamaiUrl(G_PLUS_IMAGE)} alt="Google Plus" />
                {TEXTS.REGISTER_GOOGLE}
            </Button>

            <div className="message-container">
                {(formState === FORM_STATE.LOGIN || formState === FORM_STATE.FORGOT_PASSWORD) && (
                    <>
                        {TEXTS.NEW_USER}{" "}
                        <LinkButton
                            data-cy="signup-btn"
                            onClick={() => setFormState(FORM_STATE.SIGN_UP)}
                        >
                            {TEXTS.CREATE_ACCOUNT}
                        </LinkButton>
                    </>
                )}

                {formState === FORM_STATE.SIGN_UP && (
                    <>
                        {TEXTS.ALREADY_HAVE_ACCOUNT}{" "}
                        <LinkButton
                            data-test="login-btn"
                            onClick={() => setFormState(FORM_STATE.LOGIN)}
                        >
                            {TEXTS.LOGIN_NOW}
                        </LinkButton>
                    </>
                )}
            </div>
        </Container>
    );
}

export default memo(SocialLogin);
